import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import Quote from "components/Typography/Quote.js";
// core components
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// import Muted from "components/Typography/Muted.js";
// import CardFooter from "components/Card/CardFooter.js";

//lazy loading
import Image from "next/image"

import styles from "./ServicesSections.module.scss";

export default function SectionText() {
  const classes = styles;
    // const imgClasses = classNames(
    //   classes.imgRaised,
    //   classes.imgRounded,
    //   classes.imgFluid
    // );
  return (
    <div className={classes.containerWide}>
      <GridContainer justifyContent="center">


        <GridItem xs={12} sm={12} md={12} >
          <GridContainer justifyContent="center">


            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                    
                  className={classes.imgCardTop}
                  src="/img/services/images/web-development-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    The modern web requires a modern approach to web design. SEO, design and UX are central to what we do. We can do wordpress but prefer others
                  </p>
                  <br />
                  <a href="/services/web-development-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={4} lg={2} >
              <Card style={{maxWidth: "400px", height: "85%"}}>
                <Image
                  layout = 'responsive'
                  width= {100}
                  height = {50}  
                    
                  className={classes.imgCardTop}
                  src="/img/services/images/script-development-small.webp"
                  alt="email-marketing"
                />
                <CardBody >
                  
                  <p className={classes.description}>
                    We can design scripts in various languages such as Python and Javascript - from reporting automation to whatever else you need.
                  </p>
                  <br />
                  <a href="/services/other-services"><Button color="primary" style={{position:"absolute",left:"10px",bottom:"10px"}}>Find out more</Button> </a>
                </CardBody>
              </Card>
            </GridItem>
            
            
            
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
